export default __webpack_public_path__ + "static/media/proxima.375d5d8b.png";